import { useEffect, useState } from 'react';

/** Zeigt einen Wert (mit wechselnder id) für `ms` Millisekunden an, danach null. */
export function useTransient<T extends { id: number }>(value: T | null, ms = 3_500): T | null {
  const [hiddenId, setHiddenId] = useState<number | null>(null);

  useEffect(() => {
    if (!value) return;
    const timer = window.setTimeout(() => setHiddenId(value.id), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);

  return value && value.id !== hiddenId ? value : null;
}
